import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export default function RegionHeader(props) {
    const { title, addtext=null, buttonValue, buttontext, handleButtonClick } = props;
   
	return (
		<>
			<Typography className="stnbutton-container" variant="h6" component="h2">
				{title}
				{buttonValue &&
					<Button 
						className="stnbutton"
						value={buttonValue}
						variant="outlined" 
						size="small"
						onClick={handleButtonClick}
					>
						{buttontext}
					</Button>
				}
			</Typography>
			{addtext &&
				<div sx={{maxWidth:"800px",textAlign:"center",margin:"0 auto"}}>
					<Typography sx={{lineHeight:"1.25",marginBottom:"1em"}}>
						{addtext}
					</Typography>
				</div>
			}
        </>
	);
}